// PLAT-001: Hook para actualizar document.title en cada página SPA
import { useEffect } from 'react';

/**
 * Actualiza el título de la pestaña del navegador.
 * Screen readers anuncian cambios de título al navegar entre rutas.
 */
export function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} — ProcesoFácil` : 'ProcesoFácil';
  }, [title]);
}
